package one.healthium.featureconfig.domain

sealed interface ConfigType<T> {
    data object Boolean : ConfigType<kotlin.Boolean>
    data object String : ConfigType<kotlin.String>
    data object Long : ConfigType<kotlin.Long>
    data object Double : ConfigType<kotlin.Double>
}
